<template>
  <div>
    <router-link
      v-if="permissionsSurvey('edit') || permissionsSurvey('view')"
      :to="currentRoute + '/' + getId(item) + '/detail'"
    >
      <md-button class="md-just-icon md-success md-simple table-action">
        <md-tooltip
          md-direction="top"
          v-if="permissionsSurvey('edit') && status === 'Pending'"
          >{{ $t("common.edit") }}
        </md-tooltip>
        <md-icon v-if="permissionsSurvey('edit') && status === 'Pending'"
          >edit</md-icon
        >
        <md-tooltip
          md-direction="top"
          v-if="permissionsSurvey('view') && status !== 'Pending'"
          >{{ $t("common.view") }}
        </md-tooltip>
        <md-icon v-if="permissionsSurvey('view') && status !== 'Pending'"
          >visibility</md-icon
        >
      </md-button>
    </router-link>
    <md-button
      v-if="permissionsSurvey('sendMail') && status === 'Pending'"
      @click="triggerConfirmSentMail"
      class="md-just-icon md-danger md-simple table-action"
    >
      <md-tooltip md-direction="top">{{ $t("common.send_mail") }} </md-tooltip>
      <img src="../Img/SentDate.svg" class="pt-0" />
    </md-button>

    <router-link
      v-if="permissionsSurvey('copy')"
      :to="currentRoute + '/' + getId(item) + '/clone'"
    >
      <md-button
        v-if="permissionsSurvey('copy')"
        class="md-just-icon md-warning md-simple table-action"
      >
        <md-tooltip md-direction="top"> {{ $t("common.copy") }} </md-tooltip>
        <md-icon>content_copy</md-icon>
      </md-button>
    </router-link>
    <md-button
      v-if="permissionsSurvey('delete') && status !== 'Activated'"
      class="md-just-icon md-danger md-simple table-action"
      @click="triggerConfirmDelete"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }} </md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
    <md-button
      v-if="permissionsSurvey('report') && status !== 'Pending'"
      class="md-just-icon md-danger md-simple table-action"
      @click="viewReport"
    >
      <md-tooltip md-direction="top"
        >{{ $t("survey_report.report") }}
      </md-tooltip>
      <md-icon class="text-[#9C27B0]"
        ><img class="h-5" src="../Img/Report.svg" />
      </md-icon>
    </md-button>
  </div>
</template>

<script>
import { service_names } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import { Survey } from "@/constants/Permissions";
import cloneDeep from "lodash/cloneDeep";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      status: this.item.status,
      path: `${service_names.school}/survey`,
      Survey,
      getId
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    currentRoute() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    }
  },
  inject: ["confirmSendMail", "confirmDelete"],
  methods: {
    viewReport() {
      this.$router.push({ path: `/survey-report/${getId(this.item)}` });
    },
    triggerConfirmSentMail() {
      this.confirmSendMail(cloneDeep(this.item));
    },
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    },
    permissionsSurvey(permission) {
      return (
        this.$can(Survey.actions[permission], Survey.subject) ||
        hasValidRole(this.userRole, Role.Teacher)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
::v-deep .md-button .md-ripple {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
